import { ReactNode } from 'react';

const escapeRegExp = (str: string): string => str.replace(/[.*+?^${}()|[\]\\]/g, String.raw`\$&`);

export const highlightMatchHelper = (text: string, query: string): ReactNode => {
  if (!query) return text;

  const safeQuery = escapeRegExp(query);
  const regex = new RegExp(`(${safeQuery})`, 'gi');
  const parts = text.split(regex);

  // Each part is keyed by its character offset in the text, which is unique and stable.
  let offset = 0;

  return parts.map((part) => {
    const start = offset;
    offset += part.length;

    return part.toLowerCase() === query.toLowerCase() ? (
      <mark key={start} className="bg-[#CCF4D8] ">
        {part}
      </mark>
    ) : (
      part
    );
  });
};
